import React from "react";
import { Link } from "react-router-dom";
import { IconButton } from "components";
import { Role } from "utils";

const CareHomePermissionButton = ({ user = {}, tableType }) => {
  const canManagePermissions = () => {
    // Only Admin should manage permissions
    if (Role.adminAccess()) return true;

    return false;
  };

  return canManagePermissions() ? (
    <div>
      <Link
        to={{
          pathname: `/b2b/care-home-permissions/${user?.identifier}`,
          state: {
            careHomeId: user?.identifier,
            careHomeName: user?.name,
          },
        }}
        style={{ width: "auto" }}
      >
        <IconButton
          icon="cil-lock-locked"
          name="Permission"
        />
      </Link>
    </div>
  ) : null;
};

export default CareHomePermissionButton;
